module.exports = __webpack_public_path__ + "img/check.2c705c73.png";